// apps/share-web/src/offline/setlist-prefetch-wiring.ts
//
// Единый сетлист, фазы 3+4, задача D4 — проводка «состав предстоящих
// сетлистов, потом слова именно их песен» одним вызовом из main.ts. Модуль,
// а не код в монолите: дисциплина роста (CLAUDE.md) — main.ts несёт только
// сам вызов, адаптеры сети и разбор причин отказа живут здесь.
//
// Отдельный проход от общей докачки слов (`prefetchWords`, main.ts — метёт
// ВСЮ библиотеку без порядка): этот качает раньше (`await` до соседнего
// вызова) и только то, что нужно человеку офлайн в первую очередь —
// ближайшее служение, а не весь архив команды.
import { fetchPublishedSetlist } from '../setlist.js';
import { fetchSongText } from '../song-text-api.js';
import type { TeamLibrary } from '../library.js';
import type { OfflineStore } from './offline-store.js';
import { prefetchSetlists, prefetchWordsByIds } from './prefetch.js';

export interface RunSetlistPrefetchArgs {
  store: OfflineStore;
  library: TeamLibrary[];
  apiBase: string;
  signal?: AbortSignal;
}

/**
 * Состав каждого предстоящего сетлиста (`prefetchSetlists`), затем слова
 * песен ИЗ него (`prefetchWordsByIds` по id, которые вернула докачка
 * состава). Отмена одним `signal` останавливает обе докачки — сигнал общий,
 * не два контроллера: уход со страницы посреди состава обязан остановить и
 * слова следом, а не только текущий шаг.
 */
export async function runSetlistPrefetch(args: RunSetlistPrefetchArgs): Promise<void> {
  const wordsIds = await prefetchSetlists({
    store: args.store,
    library: args.library,
    signal: args.signal,
    fetchSetlist: async (setlistId) => {
      const res = await fetchPublishedSetlist(setlistId, args.apiBase);
      if (res.ok) return { ok: true, payload: res };
      if (res.notFound) return { ok: false, reason: 'notFound' };
      if (res.needsAuth) return { ok: false, reason: 'needsAuth' };
      return { ok: false };
    },
  });
  if (args.signal?.aborted) return;
  await prefetchWordsByIds({
    store: args.store,
    teams: args.library,
    ids: wordsIds,
    signal: args.signal,
    fetchOne: async (id) => {
      const r = await fetchSongText(id, args.apiBase);
      return r.ok ? { ok: true, payload: r.payload } : { ok: false };
    },
  });
}
